export default __webpack_public_path__ + "static/media/2201.bd074884.png";